import icon from "@material-ui/icons/LocalOffer";

export const InvoiceIcon = icon;

export default {
  icon
};
